export default __webpack_public_path__ + "static/media/20.7e366fe7.jpg";